import React from 'react'
import Link from 'next/link'
import clsx from 'clsx'
import { SocialMediaUrl } from '@/types/company'
import styles from './styles.module.scss'

interface SnsIconSetProps {
  socialMediaUrls?: SocialMediaUrl[]
  className?: string
}

// SNS URL mapping configuration
const SNS_URL_CONFIG = {
  facebook: 'https://www.facebook.com/',
  twitter: 'https://www.twitter.com/',
  x: 'https://www.twitter.com/',
  youtube: 'https://www.youtube.com/',
  instagram: 'https://instagram.com/',
  linkedin: 'https://www.linkedin.com/company/',
  tiktok: 'https://www.tiktok.com/',
  line: 'https://page.line.me/',
  wantedly: 'https://www.wantedly.com/companies/',
} as const

export default function SnsIconSet({ socialMediaUrls = [], className }: SnsIconSetProps) {
  if (!socialMediaUrls.length) return null

  return (
    <div className={clsx(styles.snsIconSet, className)}>
      {socialMediaUrls.map((sns, index) => {
        // URLにプロトコルが含まれているかチェック（完全なURLかどうか）
        const isCompleteUrl = sns.url.startsWith('http://') || sns.url.startsWith('https://')

        // SNS_URL_CONFIGに対応するアイコンがあるかチェック
        const baseUrl = SNS_URL_CONFIG[sns.icon as keyof typeof SNS_URL_CONFIG]

        // 最終的なURLを構築（安全にフォールバック）
        const finalUrl = isCompleteUrl ? sns.url : baseUrl ? baseUrl + sns.url : sns.url // フォールバック：元のURLをそのまま使用

        return (
          <Link
            key={index}
            href={finalUrl}
            target='_blank'
            rel='noopener noreferrer'
            className={styles.snsIcon}
            aria-label={`${sns.name}ページを開く`}
          >
            <img
              src={`/images/icon/sns/${sns.icon}.svg`}
              className={styles.snsImg}
              alt={sns.name}
              loading='lazy'
            />
          </Link>
        )
      })}
    </div>
  )
}
